import React, { useState } from "react";
import "../styles/components/Services.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";

// Local images
import constructionImg from "../assets/reinforcement.jpg";
import reinforcementImg from "../assets/building.jpg";
import renovationImg from "../assets/interiors.jpg";
import maintenanceImg from "../assets/Maintenance.jpg";
import consultationImg from "../assets/Consultation.jpg";

const services = [
  {
    title: "Building Construction",
    desc: "From homes to commercial spaces, we build with strength and precision—delivering quality construction you can trust. Every project reflects our commitment to safety and excellence.",
    img: constructionImg,
    btn: "Start Your Project",
  },
  {
    title: "Structure Reinforcement",
    desc: "We reinforce weak or aging structures with modern techniques for lasting strength. From foundations to columns, we ensure safety and durability.",
    img: reinforcementImg,
    btn: "Reinforce My Structure",
  },
  {
    title: "Interiors Renovation",
    desc: "Give your home or office a refreshing new look. From modern designs to timeless finishes, we create interiors that blend style with comfort—customized for your lifestyle and budget.",
    img: renovationImg,
    btn: "Renovate My Space",
  },
  {
    title: "Home Maintenance",
    desc: "Keep your property safe and functional with our reliable repair services. From plumbing to painting, we handle it all to keep your home running smoothly.",
    img: maintenanceImg,
    btn: "Book Maintenance Service",
  },
  {
    title: "Property Consultation",
    desc: "Whether you want to buy, sell, rent, or invest, we are here to guide you. As trusted mediators, we connect people with the right properties and ensure smooth, fair, and hassle-free deals.",
    img: consultationImg,
    btn: "Get Property Advice",
  },
];

export default function Services() {
  const [showForm, setShowForm] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    place: "",
  });
  const [phoneError, setPhoneError] = useState("");
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  // ✅ Update this to your deployed backend API URL
 const API_URL = "https://my-backend-bay.vercel.app/api/sendEmail";


  const handleOpenForm = (serviceTitle) => {
    setSelectedService(serviceTitle);
    setShowForm(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setSelectedService("");
    setFormData({
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      place: "",
    });
    setPhoneError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneChange = (e) => {
    const val = e.target.value;
    if (/^\d{0,10}$/.test(val)) {
      setFormData((prev) => ({ ...prev, phone: val }));
      if (val.length === 10) setPhoneError("");
      else setPhoneError("Phone number must be exactly 10 digits");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.phone.length !== 10) {
      setPhoneError("Phone number must be exactly 10 digits");
      return;
    }

    try {
      const response = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, service: selectedService }),
      });

      const data = await response.json();
      if (data.success) {
        alert(`✅ Thank you! Your enquiry for "${selectedService}" has been sent.`);
        handleCloseForm();
      } else {
        alert("❌ Failed to send email. Try again later.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("⚠️ Something went wrong. Please try again later.");
    }
  };

  return (
    <section id="services" className="services-section">
      <h2 className="services-title">Our Services</h2>
      <p className="services-subtitle">
        Services delivered with the skilled hands of years of experience.
        Scalable, reliable, and perfectly in sync with your dream of building
        the ideal home.
      </p>

      <div className="services-swiper-wrapper">
        <Swiper
          className="services-swiper"
          spaceBetween={20}
          slidesPerView={3}
          navigation={{
            nextEl: ".services-next",
            prevEl: ".services-prev",
          }}
          onInit={(swiper) => {
            swiper.params.navigation.prevEl = ".services-prev";
            swiper.params.navigation.nextEl = ".services-next";
            swiper.navigation.init();
            swiper.navigation.update();
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          onSlideChange={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          breakpoints={{
            1024: { slidesPerView: 3 },
            768: { slidesPerView: 2 },
            0: { slidesPerView: 1 },
          }}
          modules={[Navigation]}
        >
          {services.map((service, index) => (
            <SwiperSlide key={index}>
              <div className="service-card">
                <div className="service-img">
                  <img src={service.img} alt={service.title} />
                </div>
                <div className="service-content">
                  <h3>{service.title}</h3>
                  <p>{service.desc}</p>
                  <button
                    className="service-btn"
                    onClick={() => handleOpenForm(service.title)}
                  >
                    {service.btn}
                  </button>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="swiper-buttons-below">
          <div className={`services-prev ${isBeginning ? "disabled" : ""}`}>
            &#10094;
          </div>
          <div className={`services-next ${isEnd ? "disabled" : ""}`}>
            &#10095;
          </div>
        </div>
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={handleCloseForm}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <span className="close-btn" onClick={handleCloseForm}>
              &times;
            </span>
            <h2>Enquiry Form</h2>
            <p className="services-note">
              <strong>Note:</strong> Services are valid within a limited range, up to Delhi NCR.
            </p>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="lastName"
                placeholder="Surname"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handlePhoneChange}
                maxLength="10"
                required
              />
              {phoneError && <span className="error-msg">{phoneError}</span>}
              <input
                type="email"
                name="email"
                placeholder="Email ID"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                type="text"
                name="place"
                placeholder="Place"
                value={formData.place}
                onChange={handleChange}
                required
              />
              <input
                type="hidden"
                name="service"
                value={selectedService}
                readOnly
              />
              <button type="submit">Submit</button>
            </form>
          </div>
        </div>
      )}
    </section>
  );
}
